import React from "react";
import Button from "react-bootstrap/Button";
import "./template-task-creation.scss";
import PropTypes from "prop-types";

const TemplateTaskCreationPanelFormBottomNew = ({
  isSubmitting,
  submitForm,
  isView,
  isEdit,
  setPanelVisibility,
}) => {
  const EnterKeySubmission = (keyEvent, submitForm) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      submitForm && submitForm();
    }
  };

  const EnterKeyCancel = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      setPanelVisibility((prev) => ({ ...prev, showCancelPanel: true }));
    }
  };

  return (
    <div className="save-back-template-task-btn">
      {!isView ? (
        <Button
          className="btn-wide"
          type="submit"
          onKeyDown={(keyEvent) => EnterKeySubmission(keyEvent, submitForm)}
          disabled={isSubmitting}
        >
          {isEdit ? "Save" : "Create"}
        </Button>
      ) : (
        <></>
      )}
      <Button
        onKeyDown={(keyEvent) => EnterKeyCancel(keyEvent)}
        className="btn-wide btn-outlined"
        onClick={() => {
          setPanelVisibility((prev) => ({
            ...prev,
            showCancelPanel: true,
          }));
        }}
      >
        Cancel
      </Button>
    </div>
  );
};

TemplateTaskCreationPanelFormBottomNew.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  submitForm: PropTypes.func.isRequired,
  isView: PropTypes.bool.isRequired,
  isEdit: PropTypes.bool.isRequired,
  setPanelVisibility: PropTypes.func.isRequired,
};
export default TemplateTaskCreationPanelFormBottomNew;
